export enum PortCallStatus {
    Tentative,
    Planned,
    Scheduled,
    Confirmed,
    Departed,
    Hidden,
    Arrived,
}

export const portCallStatusFromString = (portCallStatusStr: string) => {
    if (portCallStatusStr.toLowerCase() === 'tentative') return PortCallStatus.Tentative;
    if (portCallStatusStr.toLowerCase() === 'planned') return PortCallStatus.Planned;
    if (portCallStatusStr.toLowerCase() === 'scheduled') return PortCallStatus.Scheduled;
    if (portCallStatusStr.toLowerCase() === 'confirmed') return PortCallStatus.Confirmed;
    if (portCallStatusStr.toLowerCase() === 'departed') return PortCallStatus.Departed;
    if (portCallStatusStr.toLowerCase() === 'hidden') return PortCallStatus.Hidden;
    if (portCallStatusStr.toLowerCase() === 'arrived') return PortCallStatus.Arrived;
};
